import React from 'react';
import { RowWrapper, LeftPart, CheckBox, NameWrapper, RightPart, NameSpan } from './SiteRow';
import { ReactComponent as CheckedIcon } from '../../assets/icons/CheckedIcon.svg';

import { Fade } from '@mui/material';
import { StyledTooltip } from '../_common/StyledTooltip';
import {
  ReportFilterData,
  ReportFilterState,
  ReportsFilterDataByTypePartial,
  UserSystemGroupStrings,
} from 'store/storeTypes';
import { SinglePrinterSelectionPayload } from 'actions/reportFilterActions';

export type SystemRowProps = {
  name: string;
  siteId: string;
  systemNickName: string;
  modelId: string;
  filterState: ReportFilterState;
  filterData: ReportFilterData | ReportsFilterDataByTypePartial;
  selectedSystemGroup: UserSystemGroupStrings;
  isSingleSelectionMode: boolean;
  disabled?: boolean;
  singlePrinterSelection: ({}: SinglePrinterSelectionPayload) => void;
  toggleFilterSerialRowSystemSelection?: ({}) => void;
};
const SystemRow = (props: SystemRowProps) => {
  const {
    name: serialId,
    siteId,
    systemNickName,
    modelId,
    filterState,
    filterData,
    selectedSystemGroup,
    isSingleSelectionMode,
    disabled,
    singlePrinterSelection,
    toggleFilterSerialRowSystemSelection,
  } = props;

  const onPrinterClick = () => {
    if (disabled) return;
    if (isSingleSelectionMode) {
      singlePrinterSelection({
        serialId,
        modelId,
        siteId,
        selectedSystemGroup,
      });
    } else {
      toggleFilterSerialRowSystemSelection({
        selectedSystemGroup,
        filterState,
        filterData,
        serialId,
        modelId,
        siteId,
      });
    }
  };
  const isThisSystemSelected = filterState.selectedSystemSerials.includes(serialId);
  return (
    <>
      <RowWrapper data-testid="machine-filter-system-row">
        <LeftPart onClick={onPrinterClick} style={{ marginLeft: '30px' }}>
          <CheckBox
            data-testid="system-row-checkbox"
            checked={isThisSystemSelected}
            disabled={disabled}>
            {isThisSystemSelected && <CheckedIcon fill="white" />}
          </CheckBox>
          <StyledTooltip
            disableHoverListener={!systemNickName} // disable tooltip if no nick name
            style={{ position: 'relative' }}
            title={`nick name : ${systemNickName}`}
            placement="top"
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 300 }}>
            <NameWrapper>
              <NameSpan data-testid="system-name">
                {serialId + ' '}
                {systemNickName && `${systemNickName}`}
              </NameSpan>
            </NameWrapper>
          </StyledTooltip>
        </LeftPart>
        <RightPart></RightPart>
      </RowWrapper>
    </>
  );
};
export default SystemRow;
